import domain from './domain';

// Reset subscription plans
export const resetSubscriptionPlans = domain.createEvent('resetSubscriptionPlans');
